import $ from "jquery";

class Robust {
	constructor() {
		this.dom();
	}

	dom() {
		// Global
		this.$document = $(document);
		this.$window = $(window);
		this.$body = $('body');

		//Header
		this.$header = $("#header");

		// Content
		this.$wpcf7 = $('.wpcf7');
	}
}

export default Robust;
